import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SearchContextType {
  isMobileSearchVisible: boolean;
  toggleMobileSearch: () => void;
  hideMobileSearch: () => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

interface SearchProviderProps {
  children: ReactNode;
}

export const SearchProvider: React.FC<SearchProviderProps> = ({ children }) => {
  const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false);

  const toggleMobileSearch = () => {
    setIsMobileSearchVisible(prev => !prev);
  };

  const hideMobileSearch = () => {
    setIsMobileSearchVisible(false);
  };

  return (
    <SearchContext.Provider value={{
      isMobileSearchVisible,
      toggleMobileSearch,
      hideMobileSearch
    }}>
      {children}
    </SearchContext.Provider>
  );
};